<template>
  <div class="coupon-code">
    <dl class="coupon-dt" @click.prevent="handelShow">
      <dt>
        <p>{{ $t('兑换优惠') }}</p>
        <TermsOfUse v-if="!isH5" />
      </dt>
      <dd>
        <i class="el-icon-plus"></i>
      </dd>
    </dl>
    <TermsOfUse v-if="isH5" />
    <!-- 兑换码弹窗 -->
    <!-- <CodePopup v-model="showCode" /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TermsOfUse from './termsOfUse.vue';
// import CodePopup from './codePopup.vue';
import i18n from '@/i18n/locale';

export default {
  name: 'CouponCode',
  props: {
    isCart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showCode: false,
      i18n: i18n,
    };
  },
  components: {
    TermsOfUse,
    // CodePopup,
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
  },
  methods: {
    handelShow() {
      this.$codePopup({ isCart: this.isCart })
        .then(() => {
          this.$emit('update');
        })
        .catch(() => {
          console.log('close codePopup');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-code {
  margin: 0 auto 10px auto;
  padding-bottom: 10px;
  width: calc(100vw - 24px);
  max-width: 423px;
  top: 0;
  color: #000;
  background: #f5f5f7;
  z-index: 9;
  h2 {
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 12px;
  }
  .el-input {
    max-width: 423px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    cursor: pointer;
  }
}
.coupon-dt {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: #fff;
  padding: 16px;
  dt {
    flex: 1;
    > p {
      font-family: 'Aspira Medium';
      font-weight: 500;
      font-size: 16px;
    }
  }
  dd {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    i {
      font-size: 20px;
    }
  }
}
@media screen and (max-width: 768px) {
  .coupon-dt {
    padding: rem(40) 16px;
    border-radius: rem(12);
  }
  .coupon-code {
    .el-input {
      width: rem(702);
    }
  }
}
</style>

